module.exports = __webpack_public_path__ + "img/candidates.35276b5f.svg";